import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// Kampanyayı etkinleştirme aksiyon oluşturucusu
export const enableCampaign = createAsyncThunk(
    "enableCampaign",
    async (campaignId, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.put(`api/v1/clients/notification/campaigns/${campaignId}/enable`);
            return { campaignId, enabled: true };
        } catch (error) {
            console.error("Error enabling campaign:", error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Kampanyayı devre dışı bırakma aksiyon oluşturucusu
export const disableCampaign = createAsyncThunk(
    "disableCampaign",
    async (campaignId, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.put(`api/v1/clients/notification/campaigns/${campaignId}/disable`);
            return { campaignId, enabled: false };
        } catch (error) {
            console.error("Error disabling campaign:", error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Kampanyayı silme aksiyon oluşturucusu
export const deleteCampaign = createAsyncThunk(
    "deleteCampaign",
    async (campaignId, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.delete(`api/v1/clients/notification/campaigns/${campaignId}`);
            return { campaignId };
        } catch (error) {
            console.error("Error deleting campaign:", error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const campaignActionsSlice = createSlice({
    name: "campaignActions",
    initialState: {
        loading: false,
        error: null,
        success: false,
        actionType: null,
    },
    reducers: {
        clearCampaignActionState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.actionType = null;
        }
    },
    extraReducers: (builder) => {
        // Enable Campaign
        builder
            .addCase(enableCampaign.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.actionType = "enable";
            })
            .addCase(enableCampaign.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(enableCampaign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            
        // Disable Campaign
            .addCase(disableCampaign.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.actionType = "disable";
            })
            .addCase(disableCampaign.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(disableCampaign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            
        // Delete Campaign
            .addCase(deleteCampaign.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.actionType = "delete";
            })
            .addCase(deleteCampaign.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteCampaign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearCampaignActionState } = campaignActionsSlice.actions;
export default campaignActionsSlice.reducer; 